<template>
  <q-dialog v-model="show_downloader" seamless>
    <q-card square flat class="downloader bg-grey-10" :class="dialogPosition">
      <q-card-section>
        <div class="row q-col-gutter-md">
          <div class="col-12 text-white">
            {{ $t("downloading_content") }}
          </div>

          <div class="col-12">
            <q-linear-progress
              dark
              stripe
              rounded
              size="20px"
              :value="progress"
              color="primary"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import { writeFile } from "capacitor-blob-writer";
import { mapGetters } from "vuex";

export default {
  name: "ActivityDownloader",

  i18nOptions: { namespaces: ["custom", "common"] },

  data() {
    return {
      activities: [],
      show_downloader: false,
    };
  },

  computed: {
    ...mapGetters({
      offline_activities: "offline_course/activities",
    }),

    dialogPosition() {
      if (this.$route.meta.parent === "closed") return "menu";
      else return "no-menu";
    },

    progress() {
      let progress = 0;
      if (this.activities.length > 0) {
        progress = this.activities.reduce((acc, num, index) => {
          return (acc += num.progress);
        }, 0);
        return progress / this.activities.length;
      } else return progress;
    },
  },

  methods: {
    async downloadActivity(activity) {
      this.activities.push({
        item_id: activity.item_id,
        progress: 0,
        resource: activity.resource,
      })

      let index = this.activities.length - 1
      this.show_downloader = true
      const extension = activity.resource.split(".").pop()

      const response = await fetch(this.activities[index].resource)
      const total = Number(response.headers.get("content-length"))

      const reader = response.body.getReader()
      let bytesReceived = 0
      let chunks = []

      while (true) {
        const result = await reader.read();
        if (result.done) {
          break
        }
        chunks.push(result.value)
        bytesReceived += result.value.length
        this.activities[index].progress = (100 * bytesReceived) / total / 100
      }

      const blob = new Blob(chunks)
      const fileteste = await this.fileRender(blob)

      const result = await Filesystem.writeFile({
        path: `class${activity.item_id}.${extension}`,
        data: fileteste[0],
        directory: Directory.External,
      })

      const src = Capacitor.convertFileSrc(result.uri);
      let existing_index = this.offline_activities.findIndex(
        (e) => e.item_id === activity.item_id
      )
      let offline_activities_copy = Object.assign([], this.offline_activities);
      if (existing_index !== -1) {
        offline_activities_copy[existing_index] = {
          item_id: activity.item_id,
          updated_date: activity.updated_date,
          src: src,
          dowloading: false,
        };
      } else {
        offline_activities_copy.push({
          item_id: activity.item_id,
          updated_date: activity.updated_date,
          src: src,
          downloading: false,
        });
      }
      this.$store.dispatch("offline_course/SET_ACTIVITIES", [
        offline_activities_copy,
      ]);

      if (this.progress === 1) {
        this.activities = [];
        this.show_downloader = false;
        this.$store.dispatch("offline_course/SET_DOWNLOADING", [false]);
      }
    },

    fileRender(archiveBlob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(archiveBlob);

        reader.onload = () => {
          const data = reader.result;
          var result = data.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
          resolve(result);
        };

        reader.onerror = (e) => {
          return reject(error);
        };
      });
    },
  },

  watch: {
    progress: function() {
      if (this.progress > 0 && this.progress < 1) this.show_downloader = true;
    },
  },

  mounted() {
    this.$mitt.on("downloadActivity", (activity) => {
      this.downloadActivity(activity);
    });
  },

  beforeDestroy() {
    this.$mitt.off("downloadActivity");
  },
};
</script>

<style lang="scss" scoped>
.downloader {
	position: fixed;
	left: 0;
	width: 100vw;
}
.menu {
	bottom: 52px;
}
.no-menu {
	bottom: 0;
}
</style>
